export default "__VITE_ASSET__Ducs60k3__"